import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ReceiptModal = ({ isOpen, onClose, receiptUrl, booking, onApprove, onReject }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in" dir="rtl">
      <div className="bg-card w-full max-w-lg rounded-xl border border-border shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border">
          <div className="flex items-center gap-2">
            <Icon name="Receipt" size={20} className="text-primary" />
            <h3 className="font-semibold text-foreground">بررسی رسید پرداخت</h3>
          </div>
          <Button variant="ghost" size="icon" onClick={onClose} iconName="X" iconSize={18} />
        </div>

        {/* Content */}
        <div className="p-4 overflow-y-auto space-y-4 flex-1">
          {/* Booking Info Card */}
          <div className="bg-muted/50 rounded-lg p-3 border border-border/50 text-sm space-y-2">
            <div className="flex justify-between">
              <span className="text-muted-foreground">مشتری:</span>
              <span className="font-medium text-foreground">{booking?.clientName}</span>
            </div>
            {booking?.clientPhone && (
              <div className="flex justify-between">
                <span className="text-muted-foreground">شماره تماس:</span>
                <span className="font-medium text-foreground" dir="ltr">{booking?.clientPhone}</span>
              </div>
            )}
            <div className="flex justify-between">
              <span className="text-muted-foreground">سرویس:</span>
              <span className="font-medium text-foreground">{booking?.service?.name || booking?.service}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">متخصص:</span>
              <span className="font-medium text-foreground">{booking?.employee?.name || booking?.employee}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">مبلغ بیعانه:</span>
              <span className="font-semibold text-success">۲۰۰,۰۰۰ تومان</span>
            </div>
          </div>

          {/* Receipt Image */}
          <div className="relative border border-border rounded-lg overflow-hidden bg-black/5 flex items-center justify-center min-h-[300px]">
            {receiptUrl ? (
              <img
                src={receiptUrl}
                alt="رسید پرداخت"
                className="max-w-full max-h-[450px] object-contain"
              />
            ) : (
              <div className="text-muted-foreground flex flex-col items-center gap-2">
                <Icon name="FileX" size={32} />
                <span>رسید پرداخت یافت نشد</span>
              </div>
            )}
          </div>
        </div>

        {/* Footer actions */}
        <div className="p-4 border-t border-border bg-muted/20 flex gap-3">
          <Button
            variant="success"
            className="flex-1"
            iconName="Check"
            onClick={() => {
              onApprove(booking._id);
              onClose();
            }}
          >
            تایید رسید و رزرو
          </Button>
          <Button
            variant="danger"
            className="flex-1"
            iconName="X"
            onClick={() => {
              onReject(booking._id);
              onClose();
            }}
          >
            رد رسید و لغو رزرو
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReceiptModal;
